import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { PAYMENT_METHOD } from "../state/helpers/Payment"



type OwnProps = {
    paymentMethodType : PAYMENT_METHOD
}

const TestPaymentMethodBadge = (props: OwnProps) => {

    switch (props.paymentMethodType) {
    case PAYMENT_METHOD.BANK_ACCOUNT:
        return <span className="badge badge-warning text-danger-badge ml-2">
            <FormattedMessage
                id="cards_on_file.test_bank_account_label"
                defaultMessage="Test bank account"
            />
        </span>
    case PAYMENT_METHOD.CREDIT_CARD:
        return <span className="badge badge-warning text-danger-badge ml-2">
            <FormattedMessage
                id="cards_on_file.test_card_label"
                defaultMessage="Test card"
            />
        </span>
    default:
        return <></>
    }
}


export default injectIntl(TestPaymentMethodBadge)


// WEBPACK FOOTER //
// ./src/customer/TestPaymentMethodBadge.tsx